// Libellés des inventaires terrain, regroupés ici pour faciliter la traduction.
// Le dashboard n'a pas encore de mécanisme de traduction de son interface :
// comme le reste du dashboard, les écrans sont en français pour le moment.

export function doneCountLabel(count)
{
	if (count == null)
		return ''
	if (!count)
		return 'Aucun emplacement fait'
	if (count === 1)
		return '1 emplacement fait'
	return count + ' emplacements faits'
}

// « Julie Robert » → « Julie R. »
export function shortName(fullName)
{
	const parts = (fullName || '').trim().split(/\s+/).filter(Boolean)
	if (parts.length === 0)
		return ''
	if (parts.length === 1)
		return parts[0]
	return parts[0] + ' ' + parts[parts.length - 1].charAt(0).toUpperCase() + '.'
}

export function tourStartedByLabel(tour, user)
{
	const name = shortName(tour.create_user_name)
	if (user && tour.create_user && tour.create_user === user._id)
		return name ? 'Démarré par vous (' + name + ')' : 'Démarré par vous'
	return name ? 'Démarré par ' + name : ''
}

export function greetingLabel(user)
{
	const firstname = user && user.firstname ? user.firstname.trim() : ''
	return firstname ? 'Bonjour ' + firstname + '. Quel inventaire ?' : 'Bonjour. Quel inventaire ?'
}
